import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { AuditLogsPage } from "@/features/audit";

export const Route = createFileRoute("/audit-logs/")({
  component: AuditLogsRoute,
});

function AuditLogsRoute() {
  return (
    <AdminDashboardShell>
      <AuditLogsPage />
    </AdminDashboardShell>
  );
}
